import {atom} from 'recoil';
import {partnerPaginatedType} from '../../types/partners';

export const partnersPaginated = atom<partnerPaginatedType>({
  key: 'partner',
  default: undefined,
});
